var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHenry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 115,
    viewBox: "0 0 131 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 115,
    fill: "#FFFF00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 56V94H35.5H49V86C49 81.6 48.6 78 48.2 78C47.7 78 43.8 79.7 39.4 81.9L31.5 85.7L31.2 74.2C31.1 67.9 31.2 62.5 31.5 62.2C31.8 61.9 35.7 60.7 40.2 59.5L48.5 57.3L48.8 37.7L49 18H35.5H22V56Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65 36C65 45.9 65.3 54 65.8 54C66.2 54 72.2 53.3 79.3 52.3L92 50.6V34.3V18H78.5H65V36Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102 44.8192C102 45.3192 102.3 46.0192 102.6 46.3192C103 46.6192 103.3 50.1192 103.3 54.0192C103.4 61.0192 104.2 62.4192 106.8 59.8192C107.5 59.1192 110.9 57.6192 114.3 56.5192C119.7 54.7192 120.5 54.2192 120.8 51.8192C121.2 48.5192 118.4 47.0192 112.1 47.0192C109.9 47.0192 107.7 46.4192 107 45.5192C105.7 43.9192 102 43.4192 102 44.8192Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M79.5 65.4C72.9 67.7 66.9 69.9 66.2 70.4C65.4 70.9 65 74.6 65 82.6V94H78.5H92V77.5C92 68.4 91.9 61 91.8 61.1C91.6 61.1 86.1 63 79.5 65.4Z",
    fill: "black"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHenry);
export default __webpack_public_path__ + "static/media/LogoHenry.60013e1ba48b0a8fbd920d7d511e13c6.svg";
export { ForwardRef as ReactComponent };